import * as Config from '../../../config';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";

import DropBoxPlayer from './DropBoxPlayer';

import useCallbackPlay from '../../../hooks/useCallbackPlay';

// Tracks can be drag to player decks to load them
function ConnectedPlayerDropContainer({ dimension }) {
  const { playerCoordinates, fullHeight } = dimension;
  const callbackPlay = useCallbackPlay();
  const dropDeck = (_pid) => (source) => callbackPlay(_pid, source);
  const top = (playerCoordinates) ? playerCoordinates.top : 0;
  const height = (playerCoordinates) ? playerCoordinates.height : 0;

  return (
    <>
      <DropBoxPlayer accept={[`TRACK`, `TRACK-CARD`]} drop={dropDeck(1)} opacityLevel={0.3} zIndex={-1} style={{ background: `#1E1E1E`, width: (window.innerWidth / 2) - 175, height, position: `fixed`, top, left: (fullHeight) ? Config.SIDE_WIDTH : 0 }} />
      <DropBoxPlayer accept={[`TRACK`, `TRACK-CARD`]} drop={dropDeck(2)} opacityLevel={0.3} zIndex={-1} style={{ background: `#1E1E1E`, width: (window.innerWidth / 2) - 175, height, position: `fixed`, top, right: 0 }} />
    </>
  );
}

ConnectedPlayerDropContainer.propTypes = {
  dimension: PropTypes.object
}

const PlayerDropContainer = connect(
  state => ({
    dimension: state.dimension
  })
)(ConnectedPlayerDropContainer);

export default PlayerDropContainer;
